

/**
 * Enum to describe the http referer
 *
 * @export
 * @enum {string}
 */
export enum CortexTouchSource {
  /** @member {string} */
  /** The referer is the same domain as the current location */
  Direct = "direct",
  /** @member {string} */
  /** The referer is a different domain to the current location */
  External = "external",
  /** @member {string} */
  /** The referer was blank */
  Unknown = "unknown"
}
